var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExpandibleIconThreeLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.25H2.25C1.83579 16.25 1.5 16.5858 1.5 17C1.5 17.4142 1.83579 17.75 2.25 17.75H21.75C22.1642 17.75 22.5 17.4142 22.5 17C22.5 16.5858 22.1642 16.25 21.75 16.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11.25H2.25C1.83579 11.25 1.5 11.5858 1.5 12C1.5 12.4142 1.83579 12.75 2.25 12.75H21.75C22.1642 12.75 22.5 12.4142 22.5 12C22.5 11.5858 22.1642 11.25 21.75 11.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6.25H2.25C1.83579 6.25 1.5 6.58579 1.5 7C1.5 7.41421 1.83579 7.75 2.25 7.75H21.75C22.1642 7.75 22.5 7.41421 22.5 7C22.5 6.58579 22.1642 6.25 21.75 6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpandibleIconThreeLines);
export default __webpack_public_path__ + "static/media/ic-expandible-icon-three-lines.d17fcb4915f896ebc65e9711cd8a8c4b.svg";
export { ForwardRef as ReactComponent };